var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFeature2 = function SvgIconFeature2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_feature_2",
    "data-name": "Icon/feature 2",
    width: 151,
    height: 138,
    viewBox: "0 0 151 138",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_2",
    "data-name": "Icon 2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "feature_4",
    "data-name": "feature 4",
    width: 151,
    height: 138,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Carbon_CC",
    "data-name": "Carbon CC",
    transform: "translate(37 19)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "icons8-invoice-100",
    width: 76,
    height: 92,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABcCAYAAADEQVOwAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAATKADAAQAAAABAAAAXAAAAAB2WVBiAAACYklEQVR4Ae2YTU4EIRCFZ4zeZa7iQs8/K6MLTbyECokLisBUPeg23fbXCckAj7+PB1Pd59Pp9J0ST5DAXVCH7JcAwEQrAEwEdt/QnxtlRy4ydzwOE60AMICJBEQ5DgOYSECU4zCAiQREOQ4DmEhAlOMwgIkERDkOA5hIQJTjMICJBER563tYtAvznSjaaEO6oe9+HElxBwEGMJGAKJ+5w4buAHF+m5NzJMUtARjARAKiHIcBTCQgynEYwEQConzGYc9prM+U8jvlnlKe81NKw0+92GhHH0lYt91L/j26yHqNOVrPiyyfaAT/lRpFtWX/W/id1xw9XYZPtFFrkXuFldcyPPeZd8kaYj0JszMzk6wHqvLRcWpd1U0sO+Ow2Aj/TAUwcUMBBjCRgCjHYQATCYhyHCYCWzIO8+Icr16cele+6jg4rMu9XQGwNpduKcC6aNoVS95hvEu2GR+7lCMp7j/AACYSEOU4DGAiAVGOw0RgS8Zh3jucVy9OvStfdRwc1uXergBYm0u3FGBdNO2KJe8w3iXbjI9dypEU9x9gABMJiHIc9ofA3qqxcoRdpqra1JW62d/RcUrda5lRfs84bKatMsc1tA+jne550aNrnm5XH4loh49J+JJS3X7r+TznPPfoY9aTo/NcUD51xF7WHfG34cORFC0AMICJBEQ5DgOYSECUL/k9TBz6tvx6vZp/p9tqvfZyuQxFAxxJkTXAACYSEOVE+j4wc5dyJH1gRgEwg8PPAMxnZBQAMzj8DMB8RkYBMIPDzwDMZ2QUrTjMCMhYAjjM8nBzAHMRWQHALA839wNhK91SRvBWgwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(47 64)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "C",
    transform: "translate(54 68)",
    fontSize: 32,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700,
    letterSpacing: "0.011em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.084,
    y: 26
  }, "C"))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFeature2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-feature-2.7e30a689.svg";
export { ForwardRef as ReactComponent };